<template lang="pug">
	.layout-workspace-toggler(v-if="User.loaded && User.currentUser && Layout.workspace")
		.selected-workspace(v-pseudo-modal-show="'workspace-dropdown'") {{Metadata.WorkspacesByCodename[Layout.workspace].title}}
			.dropdown-menu(v-pseudo-modal="'workspace-dropdown'" :style="{'max-height': `90vh`}")
				.dropdown-item(v-for="workspace in Metadata.Workspaces" @click="setWorkspace(workspace.codename)")
					i.fa(:class="workspace.options.icon" :style="{color: workspace.options.color}")
					span {{workspace.title}}
					span.badge(:style="{backgroundColor: workspace.options.color}") {{Project.getOrderedProjectsList(Publisher.SelectedPublisher, Layout.page, workspace.codename).length}}
</template>

<script>
	import Screen from './../../mixins/screen'

	import { Layout } from './../../services/Layout'
	import { User } from './../../services/User'
	import { Publisher } from './../../services/Publisher'
	import { Project } from './../../services/Project'
	import { Settings } from './../../services/Settings'
	import { Version } from './../../services/Version'

	export default {
		name: 'LayoutWorkspaceToggler',
		mixins: [Screen],
		screen: {
			updateOn: ["Selected Version Changed", "Current User Changed"]
		},
		props: {
			defaultOpen: {
				type: Boolean,
				default: false
			},
			display: {
				type: String,
				default: ''
			},
			mobile: {
				type: Boolean,
				default: false
			},
		},
		data() {

			this.User = User;
			this.Publisher = Publisher;
			this.Project = Project;
			this.Settings = Settings;
			this.Version = Version;

			return {
				showed: true
			};

		},
		methods: {
			setWorkspace(workspace) {

				Layout.setLayoutWorkspace(workspace);

			}
		}
	}
</script>

<style lang="sass" scoped>

	.layout-workspace-toggler
		position: absolute
		margin-top: -5px
		margin-right: 7px
		margin-left: 10px
		left: 300px
		z-index: 2
		top: 14px

		.selected-workspace
			border: 1px solid #23282c
			border-radius: 0.25rem
			background: #343b41 url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 4 5'%3e%3cpath fill='%23ffffff' d='M2 0L0 2h4zm0 5L0 3h4z'/%3e%3c/svg%3e") no-repeat right 0.75rem center/8px 10px
			padding-top: 0.25rem
			padding-bottom: 0.25rem
			padding-left: 0.75rem
			padding-right: 2rem
			color: #fff
			cursor: pointer
			font-size: 0.765625rem

			.dropdown-menu
				top: 28px
				border-color: #5b5b66
				width: 100px
				margin: 0
				padding: 0

				.dropdown-item
					display: flex
					flex-direction: row
					justify-content: start
					padding: 0.25rem
					padding-left: 0.75rem
					font-size: 0.765625rem

					.fa
						display: flex
						align-items: center
						justify-content: center

					.badge
						color: #fff

		.custom-select
			cursor: pointer
			color: #fff
			width: auto
			background: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 4 5'%3e%3cpath fill='%23ffffff' d='M2 0L0 2h4zm0 5L0 3h4z'/%3e%3c/svg%3e") no-repeat right 0.75rem center/8px 10px
			background-color: #343b41
			border: 1px solid #23282c
			margin-top: 0
			float: none !important

			&.selected
				background-color: #4dbd74
				border-radius: 0.25rem

</style>
